import { isNil } from 'lodash';

import { AnyVoiceResponseCommand, IVROption, SupportedLanguages, VoiceResponseCommand } from '@pwp-common';

import { ServiceCommandEditorOutput } from '../../../../service-operation-editor/editor-output/service-command-editor-output';
import { IVROptionEditorOutput } from '../ivr-option-editor-output';

const deserializeCommand = (serializedCommand: ServiceCommandEditorOutput): VoiceResponseCommand =>
  AnyVoiceResponseCommand.deserialize(serializedCommand);

export const ivrOptionEditorOutputToDb = (params: {
  originalIvrOption: IVROption;
  ivrOptionEditorOutput: IVROptionEditorOutput;
}): IVROption => {
  const { originalIvrOption, ivrOptionEditorOutput } = params;

  if (isNil(originalIvrOption) || isNil(ivrOptionEditorOutput)) {
    return originalIvrOption;
  }

  const commands = (ivrOptionEditorOutput.commands?.commands ?? []).map(deserializeCommand);

  const phrases = originalIvrOption.getPhrases();
  phrases.set(SupportedLanguages.en.getShortCode(), ivrOptionEditorOutput.phrases ?? []);

  return new IVROption({
    displayName: ivrOptionEditorOutput.displayName,
    description: ivrOptionEditorOutput.description,
    keyPresses: ivrOptionEditorOutput.keyPresses,
    phrases,
    commands,
  });
};
